import styles from './Navbar.module.scss';
import { Flex, Image, Text } from '@chakra-ui/react';
import DurinLogo from '../assets/logo.png';
import DurinLogoText from '../assets/logo_text.svg';
import { useNavigate } from 'react-router-dom';

const Navbar = ({
    jsxToRight,
}: {
    jsxToRight?: React.ReactNode;
}) => {
    const navigate = useNavigate();

    return (
        <Flex
            as="nav"
            className={styles.navbar}
            align="center"
            justify="space-between"
            h={["52px", "68px"]}
            px={[4, 6, 8, 12]}
            py={[3, 4]}
            bg="white"
            boxShadow="sm"
            width="100%"
        >
            <Flex
                align="center"
                cursor="pointer"
                onClick={() => navigate('/')}
                zIndex={100}
                className={styles.logoContainer}
            >
                <Image
                    src={DurinLogo}
                    alt="Logo"
                    className={styles.logo}
                    h={['28px', '36px']}
                />
                <Image
                    src={DurinLogoText}
                    alt="Logo"
                    className={styles.logoText}
                    ml={['-35px', '-39px']}
                    h={['27px', '35px']}
                    w={['132px', '152px']}
                />
            </Flex>

            {jsxToRight || (
                <Text
                    className={styles.tagline}
                    fontSize={['12px', '16px']}
                    display="block"
                    onClick={() => window.open('https://durin.com', '_blank')}
                    cursor="pointer"
                >
                    It's Time to Mine
                </Text>
            )}
        </Flex>
    );
};

export default Navbar;
